import React, { useMemo } from 'react';
import { Advnprops } from './type';
import './style.less'

const ActiveList: React.FC<Advnprops> = (props) => {
    const list = useMemo(() => {
        return props.list || [];
    }, [props.list]);




    return (
        <div className="paddlenlp-core">

            <div className="advantage-card-wrapper">
                {
                    list.map(item =>
                        <div className="paddlenlp-alln">
                            <div className="paddlenlp-background">
                                <div
                                    className="paddlenlp-picture-card-img"
                                    style={{ backgroundImage: item.imageUrl ? `url(${item.imageUrl})` : undefined }}
                                />
                            </div>
                            <div className="paddlenlp-advantage-content">
                                <p className="content-title-haa">{item.title}</p>
                            </div>
                        </div>

                    )
                }

            </div>

        </div>
    );
};

export default ActiveList;
